import { motion } from "framer-motion";
import { type ButtonHTMLAttributes, type ReactNode } from "react";

type Variant = "primary" | "ghost" | "acid";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: Variant;
  size?: "md" | "lg";
};

const variantClasses: Record<Variant, string> = {
  primary:
    "bg-witch text-bone hover:bg-mystic hover:text-void border-black",
  ghost:
    "bg-transparent text-bone hover:bg-bruise border-mystic",
  acid:
    "bg-acid text-void hover:bg-bone border-black",
};

export function PixelButton({
  children,
  variant = "primary",
  size = "md",
  className = "",
  ...props
}: Props) {
  // py-3/py-4 ensures buttons hit ≥44px touch target on mobile.
  const sz = size === "lg" ? "px-6 py-4 text-sm" : "px-4 py-3 text-xs";
  return (
    <motion.button
      whileHover={{ y: -2 }}
      whileTap={{ y: 2, x: 2 }}
      transition={{ type: "spring", stiffness: 600, damping: 20 }}
      {...(props as any)}
      className={`
        relative font-display tracking-tight uppercase
        border-2 ${variantClasses[variant]}
        ${sz} ${className}
        shadow-[4px_4px_0_0_#000]
        hover:shadow-[2px_2px_0_0_#000]
        active:shadow-[0_0_0_0_#000]
        transition-shadow
      `}
    >
      {children}
    </motion.button>
  );
}
